import { render, staticRenderFns } from "./IdentityBug.vue?vue&type=template&id=291a83d4&"
import script from "./IdentityBug.vue?vue&type=script&lang=js&"
export * from "./IdentityBug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports